function formCtr(){
	var $textarea = $('textarea');
	$('form').on('submit', onSubmit);

	//onSubmit
	function onSubmit(){
		var text = $textarea.val();
		var isHTML = text.match(/<("[^"]*"|'[^']*'|[^'">])*>/i);
		var isEscape = text.match(/(\&lt;|\&gt;)/);
		var isURL = text.match(/(http:\/\/[\x21-\x7e]+)/i);

		if(isHTML || isEscape){
			alert('お問い合わせ内容にHTMLタグは入力できません');
			return false;
		}
	}

	var $btnPrivacy = $('.btnPrivacy input');
	var $btnArea = $('.btnArea .form__submit');

	$btnPrivacy.prop("checked", false);
	$btnArea.attr("disabled", "disabled");
	$btnArea.addClass('is--lock');

	$btnPrivacy.click(function(){
		var btnType = $btnArea.attr('type');
		if( this.checked){
			$btnArea.removeAttr("disabled");
			$btnArea.removeClass('is--lock');
		}else{
			$btnArea.attr("disabled", "disabled");
			$btnArea.addClass('is--lock');
		}
	});
}

module.exports = formCtr;


// WEBPACK FOOTER //
// ./es2015/_form.js